function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z",
  fill: "#F7F7F8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.7071 13.2929C26.3166 12.9024 25.6834 12.9024 25.2929 13.2929L22.2933 16.2925C22.2932 16.2926 22.293 16.2928 22.2929 16.2929C22.2928 16.293 22.2927 16.2932 22.2925 16.2933L15.2929 23.2929C15.1533 23.4325 15.0582 23.6103 15.0194 23.8039L14.0194 28.8039C13.9539 29.1317 14.0565 29.4707 14.2929 29.7071C14.5293 29.9435 14.8683 30.0462 15.1961 29.9806L20.1961 28.9806C20.3897 28.9419 20.5675 28.8467 20.7071 28.7071L27.7071 21.7071L30.7071 18.7071C31.0976 18.3166 31.0976 17.6834 30.7071 17.2929L26.7071 13.2929ZM27 19.5858L28.5858 18L26 15.4142L24.4142 17L27 19.5858ZM23 18.4142L25.5858 21L19.507 27.0788L16.2748 27.7252L16.9212 24.493L23 18.4142Z",
  fill: "#4D4D4D"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.40ad81a0.svg";
export { ForwardRef as ReactComponent };